import LazyLoad from "vanilla-lazyload";
//import Masonry from "masonry-layout";
//import Cookies from "js-cookie";
const Flickity = require("flickity-fade");
import socialIcons from "social-icons";
import arRows from "ar-rows";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollSmoother from "gsap/ScrollSmoother";
import SplitText from "gsap/SplitText";
import DrawSVGPlugin from "gsap/DrawSVGPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText, DrawSVGPlugin);
import zenscroll from "zenscroll";
import { Loader } from "@googlemaps/js-api-loader";
import Player from "@vimeo/player";
import slide from "flickity/js/slide";

/* SETUP VARS */
let bw = document.body.scrollWidth;
let dpr = window.devicePixelRatio;
const body = document.querySelector("body");
const menuBtn = document.querySelector(".menuBtn");
let socialEl = document.querySelectorAll(".social");
let rowsEl = document.querySelectorAll(".ar-rows");
const nav = document.querySelector("nav");
const overlay = document.getElementById("overlay");
let overlayInner, overlayCloser;
if (typeof overlay != "undefined" && overlay != null) {
  overlayInner = overlay.querySelector(".inner");
  overlayCloser = overlay.querySelector(".closer");
}

window.addEventListener("load", function () {
  body.classList.remove("preload");
});

document.addEventListener("DOMContentLoaded", function () {
  /* ***************************************** */
  /* INITIALIZATION ON PAGE LOAD */
  /* ***************************************** */

  //create scrollSmoother before scrollTriggers
  let siteScroll = ScrollSmoother.create({
    smooth: 1.5,
    effects: true,
  });

  // global animation effects

  ScrollTrigger.batch(".slideUp", {
    onEnter: (elements, triggers) => {
      gsap.to(elements, {
        duration: 0.6,
        opacity: 1,
        y: 0,
        clipPath: "inset(0% 0% 0% 0%)",
        stagger: 0.2,
      });
    },
  });

  ScrollTrigger.batch(".fadeUp", {
    onEnter: (elements, triggers) => {
      gsap.to(elements, { opacity: 1, y: 0, stagger: 0.15 });
    },
  });

  ScrollTrigger.batch(".fadeOn", {
    onEnter: (elements, triggers) => {
      gsap.to(elements, { opacity: 1, stagger: 0.1 });
    },
  });

  setTimeout(function () {
    ScrollTrigger.batch(".fadeUpDelay", {
      onEnter: (elements, triggers) => {
        gsap.to(elements, { opacity: 1, y: 0, stagger: 0.15 });
      },
    });
  }, 300);

  //   let title = document.querySelector(".title");
  // if (typeof title != "undefined" && title != null) {
  //   titleText = title.querySelector("h1");
  //   let splitTitleText = new SplitText(titleText, { type: "chars" });
  //   let titleTL = gsap.timeline();
  //     titleTL.to(splitTitleText.chars, {
  //       y: 0,
  //       ease: "power4.out",
  //       stagger: 0.3,
  //       opacity: 1,
  //     });
  //   }

  // check for any social icons
  if (typeof socialIcons != "undefined") {
    socialIcons(socialEl);
  }

  // init AR Rows type layout
  if (typeof arRows != "undefined") {
    arRows(rowsEl);
  }

  // resizing of iframes for inline video playback
  let iframeEls = document.querySelectorAll("iframe");
  iframeEls.forEach((iframeEl) => {
    resizeFrame(iframeEl);
  });

  // any cols from text editor need to be wrapped in cols class
  let textCols = document.querySelectorAll(".text-block");
  for (var i = 0; i < textCols.length; i++) {
    wrapCols(textCols[i]);
  }

  //initialize lazyload - sitewide for image
  const lazyLoad = new LazyLoad({
    elements_selector: ".loadmeview",
    callback_enter: loadImage,
  });

  //initialize lazyload - autoplay videos
  const lazyLoadAutoVideo = new LazyLoad({
    elements_selector: ".autovideo",
    threshold: 30,
    callback_enter: playAutoVideo,
    callback_exit: pauseAutoVideo,
  });

  // setup hover videos with the class of .hovervideo
  let hoverVideoEls = document.querySelectorAll(".hovervideo");
  hoverVideoEls.forEach((hoverVideoEl) => {
    hoverVideoEl.addEventListener("mouseenter", function () {
      playAutoVideo(hoverVideoEl);
    });
    hoverVideoEl.addEventListener("mouseleave", function () {
      pauseAutoVideo(hoverVideoEl);
    });
  });

  // initialize masonry

  let masonGrids = document.querySelectorAll(".masongrid");
  masonGrids.forEach((masonGrid) => {
    //injecting bottom margin into masonry cell
    let gutterWidth = masonGrid.querySelector(".gutter-sizer").scrollWidth;
    let cells = masonGrid.getElementsByClassName("cell");
    for (var i = 0; i < cells.length; i++) {
      cells[i].style.marginBottom = gutterWidth + "px";
    }

    const msnry = new Masonry(masonGrid, {
      itemSelector: ".cell",
      columnWidth: ".grid-sizer",
      gutter: ".gutter-sizer",
    });
    msnry.layout();

    function onLayoutComplete() {
      // run lazyload after masonry has run
      const masonLoad = new LazyLoad({
        elements_selector: ".masonlazy",
      });
    }
    msnry.on("layoutComplete", onLayoutComplete);
  });

  let heroFlkty;

  function slideshowInit() {
    // flickity for hero section
    let heroSlideshowEls = document.querySelectorAll(".hero");
    heroSlideshowEls.forEach((heroSlideshowEl) => {
      if (heroSlideshowEl.classList.contains("project")) {
        if (innerWidth < 768) {
          let mediaEl = heroSlideshowEl.querySelector(".media");
          let aspectRatio = mediaEl.getAttribute("data-aspect-ratio");
          heroSlideshowEl.style.paddingTop = aspectRatio + "%";
        }
        return;
      }

      let autoPlaySpeed = 0;
      if (heroSlideshowEl.classList.contains("autoplay_yes")) {
        autoPlaySpeed = 5000;
      }

      heroFlkty = new Flickity(heroSlideshowEl, {
        // options
        fade: true,
        cellSelector: ".cell",
        pageDots: false,
        autoPlay: autoPlaySpeed,
        pauseAutoPlayOnHover: false,
        prevNextButtons: false,
      });
    });

    //initialize flickity for slideshows

    let slideshowEls = document.querySelectorAll(".slideshow");

    slideshowEls.forEach((slideshowEl) => {
      let autoPlaySpeed = 0;
      if (slideshowEl.classList.contains("autoplay_yes")) {
        autoPlaySpeed = 5000;
      }

      let flkty = new Flickity(slideshowEl, {
        // options
        fade: true,
        cellSelector: ".cell",
        pageDots: true,
        autoPlay: autoPlaySpeed,
        pauseAutoPlayOnHover: false,
        prevNextButtons: false,
      });
      //split text animation for h2
      let quote = slideshowEl.querySelectorAll("h2");
      let splitQuote = new SplitText(quote, { type: "lines" });
      let quoteTL = gsap.timeline();
      quoteTL.from(splitQuote.lines, {
        y: 100,
        ease: "power4.out",
        delay: 1,
        skewY: 7,
        stagger: {
          ammount: 0.3,
        },
      });
    });
  }

  //Split Line Heading animations
  let titletexts = document.querySelectorAll(".split_lines");

  titletexts.forEach((titletext) => {
    // hide the paragraphs that follow the title until the lines animate in
    let parentTextBlock = titletext.closest(".text-block");
    let parentParagraphs = parentTextBlock
      ? Array.from(parentTextBlock.querySelectorAll("p")).filter(
          (p) => p !== titletext,
        )
      : [];
    gsap.set(parentParagraphs, { opacity: 0 });
  });

  // wait for web fonts so the lines split where they'll actually wrap
  document.fonts.ready.then(function () {
    titletexts.forEach((titletext) => {
      let parentTextBlock = titletext.closest(".text-block");
      let parentParagraphs = parentTextBlock
        ? Array.from(parentTextBlock.querySelectorAll("p")).filter(
            (p) => p !== titletext,
          )
        : [];

      // split the title into lines and put them in their start position before showing the title
      let splitTitleText = new SplitText(titletext, { type: "lines" });
      gsap.set(splitTitleText.lines, {
        y: 50,
        opacity: 0,
        skewY: 2,
        clipPath: "inset(0% 0% 50% 0%)",
      });
      gsap.set(titletext, { opacity: 1 });

      // as the element scrolls into view, animate the lines
      ScrollTrigger.batch(splitTitleText.lines, {
        once: true,
        onEnter: (elements, triggers) => {
          const tl = gsap.timeline();
          tl.to(elements, {
            y: 0,
            opacity: 1,
            skewY: 0,
            clipPath: "inset(0% 0% 0% 0%)",
            stagger: 0.2,
            ease: "power4.out",
            duration: 1,
            delay: 0.3,
          }).to(
            parentParagraphs,
            {
              opacity: 1,
              duration: 0.5,
            },
            "-=0.4",
          ); // start fading in paragraphs 0.4s before lines finish
        },
      });
    });
  });

  //NOTE: unsure how to incorporate this with flickity, since all slides are preloaded
  // so the gsap animations don't show when slides change. I could loop the h2 animations
  // to match with the timing of autoPlay?
  // But then we if user control takes over, then the animations will be out of sync.
  // Stop h2 animations on user control?

  /* HANDLE CELLS THAT REQUIRE RATIO SIZING */
  let ratioCells = document.getElementsByClassName("ratioSize");
  for (let i = 0; i < ratioCells.length; i++) {
    ratioSize(ratioCells[i]);
  }

  /* HANDLE IMAGES THAT REQUIRE RESIZE IMAGE FUNCTION */
  let resizeImageCells = document.getElementsByClassName("resize-image");
  for (let i = 0; i < resizeImageCells.length; i++) {
    resizeImage(resizeImageCells[i]);
  }

  /* Initialize Google Maps */

  let mapEl = document.getElementById("map");
  if (typeof mapEl != "undefined" && mapEl != null) {
    let map;

    const loader = new Loader({
      apiKey: "AIzaSyCc3XzSkHqNWrb2nEbItJFSRsO7Wei-ug4",
      version: "weekly",
      // ...additionalOptions,
    });

    loader.load().then(async () => {
      // import in needed libraries
      const { Map } = await google.maps.importLibrary("maps");
      const { marker } = await google.maps.importLibrary("marker");

      // office location
      const position = { lat: 33.9801, lng: -118.40631 };

      map = new Map(document.getElementById("map"), {
        center: position,
        zoom: 12,
        styles: [
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              {
                color: "#e9e9e9",
              },
              {
                lightness: 17,
              },
            ],
          },
          {
            featureType: "landscape",
            elementType: "geometry",
            stylers: [
              {
                color: "#f5f5f5",
              },
              {
                lightness: 20,
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#ffffff",
              },
              {
                lightness: 17,
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#ffffff",
              },
              {
                lightness: 29,
              },
              {
                weight: 0.2,
              },
            ],
          },
          {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [
              {
                color: "#ffffff",
              },
              {
                lightness: 18,
              },
            ],
          },
          {
            featureType: "road.local",
            elementType: "geometry",
            stylers: [
              {
                color: "#ffffff",
              },
              {
                lightness: 16,
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
              {
                color: "#f5f5f5",
              },
              {
                lightness: 21,
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
              {
                color: "#dedede",
              },
              {
                lightness: 21,
              },
            ],
          },
          {
            elementType: "labels.text.stroke",
            stylers: [
              {
                visibility: "on",
              },
              {
                color: "#ffffff",
              },
              {
                lightness: 16,
              },
            ],
          },
          {
            elementType: "labels.text.fill",
            stylers: [
              {
                saturation: 36,
              },
              {
                color: "#333333",
              },
              {
                lightness: 40,
              },
            ],
          },
          {
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "transit",
            elementType: "geometry",
            stylers: [
              {
                color: "#f2f2f2",
              },
              {
                lightness: 19,
              },
            ],
          },
          {
            featureType: "administrative",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#fefefe",
              },
              {
                lightness: 20,
              },
            ],
          },
          {
            featureType: "administrative",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#fefefe",
              },
              {
                lightness: 17,
              },
              {
                weight: 1.2,
              },
            ],
          },
        ],
      });

      new google.maps.Marker({
        position: position,
        map,
        title: "Sense",
      });
    });
  }

  /* ***************************************** */
  /* FUNCTIONS */
  /* ***************************************** */
  //Horizontal Loop
  function horizontalLoop(items, config) {
    items = gsap.utils.toArray(items);
    config = config || {};
    let tl = gsap.timeline({
        repeat: config.repeat,
        paused: config.paused,
        defaults: { ease: "none" },
        onReverseComplete: () =>
          tl.totalTime(tl.rawTime() + tl.duration() * 100),
      }),
      length = items.length,
      startX = items[0].offsetLeft,
      times = [],
      widths = [],
      xPercents = [],
      curIndex = 0,
      pixelsPerSecond = (config.speed || 1) * 100,
      snap =
        config.snap === false ? (v) => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
      populateWidths = () =>
        items.forEach((el, i) => {
          widths[i] = parseFloat(gsap.getProperty(el, "width", "px"));
          xPercents[i] = snap(
            (parseFloat(gsap.getProperty(el, "x", "px")) / widths[i]) * 100 +
              gsap.getProperty(el, "xPercent"),
          );
        }),
      getTotalWidth = () =>
        items[length - 1].offsetLeft +
        (xPercents[length - 1] / 100) * widths[length - 1] -
        startX +
        items[length - 1].offsetWidth *
          gsap.getProperty(items[length - 1], "scaleX") +
        (parseFloat(config.paddingRight) || 0),
      totalWidth,
      curX,
      distanceToStart,
      distanceToLoop,
      item,
      i;
    populateWidths();
    gsap.set(items, {
      // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
      xPercent: (i) => xPercents[i],
    });
    gsap.set(items, { x: 0 });
    totalWidth = getTotalWidth();
    for (i = 0; i < length; i++) {
      item = items[i];
      curX = (xPercents[i] / 100) * widths[i];
      distanceToStart = item.offsetLeft + curX - startX;
      distanceToLoop =
        distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
      tl.to(
        item,
        {
          xPercent: snap(((curX - distanceToLoop) / widths[i]) * 100),
          duration: distanceToLoop / pixelsPerSecond,
        },
        0,
      )
        .fromTo(
          item,
          {
            xPercent: snap(
              ((curX - distanceToLoop + totalWidth) / widths[i]) * 100,
            ),
          },
          {
            xPercent: xPercents[i],
            duration:
              (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond,
            immediateRender: false,
          },
          distanceToLoop / pixelsPerSecond,
        )
        .add("label" + i, distanceToStart / pixelsPerSecond);
      times[i] = distanceToStart / pixelsPerSecond;
    }
    function toIndex(index, vars) {
      vars = vars || {};
      Math.abs(index - curIndex) > length / 2 &&
        (index += index > curIndex ? -length : length); // always go in the shortest direction
      let newIndex = gsap.utils.wrap(0, length, index),
        time = times[newIndex];
      if (time > tl.time() !== index > curIndex) {
        // if we're wrapping the timeline's playhead, make the proper adjustments
        vars.modifiers = { time: gsap.utils.wrap(0, tl.duration()) };
        time += tl.duration() * (index > curIndex ? 1 : -1);
      }
      curIndex = newIndex;
      vars.overwrite = true;
      return tl.tweenTo(time, vars);
    }
    tl.next = (vars) => toIndex(curIndex + 1, vars);
    tl.previous = (vars) => toIndex(curIndex - 1, vars);
    tl.current = () => curIndex;
    tl.toIndex = (index, vars) => toIndex(index, vars);
    tl.updateIndex = () =>
      (curIndex = Math.round(tl.progress() * (items.length - 1)));
    tl.times = times;
    tl.progress(1, true).progress(0, true); // pre-render for performance
    if (config.reversed) {
      tl.vars.onReverseComplete();
      tl.reverse();
    }
    if (config.draggable && typeof Draggable === "function") {
      let proxy = document.createElement("div"),
        wrap = gsap.utils.wrap(0, 1),
        ratio,
        startProgress,
        draggable,
        dragSnap,
        roundFactor,
        align = () =>
          tl.progress(
            wrap(startProgress + (draggable.startX - draggable.x) * ratio),
          ),
        syncIndex = () => tl.updateIndex();
      typeof InertiaPlugin === "undefined" &&
        console.warn(
          "InertiaPlugin required for momentum-based scrolling and snapping. https://greensock.com/club",
        );
      draggable = Draggable.create(proxy, {
        trigger: items[0].parentNode,
        type: "x",
        onPress() {
          startProgress = tl.progress();
          tl.progress(0);
          populateWidths();
          totalWidth = getTotalWidth();
          ratio = 1 / totalWidth;
          dragSnap = totalWidth / items.length;
          roundFactor = Math.pow(
            10,
            ((dragSnap + "").split(".")[1] || "").length,
          );
          tl.progress(startProgress);
        },
        onDrag: align,
        onThrowUpdate: align,
        inertia: true,
        snap: (value) => {
          let n =
            Math.round(parseFloat(value) / dragSnap) * dragSnap * roundFactor;
          return (n - (n % 1)) / roundFactor;
        },
        onRelease: syncIndex,
        onThrowComplete: () => gsap.set(proxy, { x: 0 }) && syncIndex(),
      })[0];
    }

    return tl;
  }
  function sizeloadVideo(el, preload) {
    let desktopSrc = el.getAttribute("data-hd"),
      mobileSrc = el.getAttribute("data-sd"),
      videoSourceEl = el.querySelector("source");

    if (window.innerWidth > 896) {
      videoSourceEl.setAttribute("src", desktopSrc);
    } else {
      videoSourceEl.setAttribute("src", mobileSrc);
    }
    el.load();
    if (preload !== "yes") {
      el.play();
    }
  }

  // check for any size load videos on page load
  let sizeLoadVideoEls = document.querySelectorAll("video.sizeload");
  sizeLoadVideoEls.forEach((sizeLoadVideoEl) => {
    sizeloadVideo(sizeLoadVideoEl, "no");
  });

  function playAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector(".vidhold video");
    if (typeof videoEl != "undefined" && videoEl != null) {
      videoEl.play();
    } else {
      let videoStr = el.getAttribute("data-autovideo");
      let videoHold = el.querySelector(".vidhold");
      videoHold.innerHTML = videoStr;
      videoEl = videoHold.querySelector("video");
      if (videoEl.classList.contains("sizeload")) {
        sizeloadVideo(videoEl, "yes");
      }
      videoEl.play();
    }
    el.classList.add("autoplaying");
  }

  function pauseAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector(".vidhold video");
    videoEl.pause();
    el.classList.remove("autoplaying");
  }

  function loadImage(image) {
    let img = image.getAttribute("data-img"),
      newW = image.classList.contains("bg-loadme")
        ? image.offsetWidth * dpr
        : image.parentNode.offsetWidth * dpr,
      fullpath = "",
      imgpath = "";

    if (!image.classList.contains("gif")) {
      if (newW <= 500) {
        imgpath = "/images/pics/500/" + img;
      } else if (newW > 500 && newW <= 750) {
        imgpath = "/images/pics/750/" + img;
      } else if (newW > 750 && newW <= 1000) {
        imgpath = "/images/pics/1000/" + img;
      } else if (newW > 1000 && newW <= 1536) {
        imgpath = "/images/pics/1536/" + img;
      } else if (newW > 1536 && newW <= 1920) {
        imgpath = "/images/pics/1920/" + img;
      } else {
        imgpath = "/images/pics/" + img;
      }
    } else {
      // load jpg as placeholder, when gif loaded swap
      imgpath = "/images/pics/500/" + img;
      fullpath = "/images/pics/" + img;

      var fullimg = new Image();
      fullimg.onload = function () {
        var fullImgSrc = fullimg.getAttribute("src");
        image.src = fullImgSrc;
        //$('.photo[data-src="' + img + '"]').attr("src", fullImgSrc);
      };
      fullimg.src = fullpath;
    }

    if (image.classList.contains("bg-loadme")) {
      $("<img/>")
        .attr("src", imgpath)
        .on("load", function () {
          $(this).remove();
          image
            .css("background-image", "url(" + imgpath + ")")
            .addClass("loaded");
        });
    } else {
      let newimage = new Image();
      newimage.onload = function () {
        image.src = imgpath;
        //image.classList.add("loaded");
      };
      newimage.src = imgpath;
    }
  }

  function wrapCols(el) {
    let elContainer = document.createElement("div");
    Array.prototype.forEach.call(el.querySelectorAll(".col"), function (c) {
      elContainer.appendChild(c);
    });
    elContainer.classList.add("cols");
    el.appendChild(elContainer);
  }

  // AJAX GET
  function getAjax(url, success) {
    var xhr = window.XMLHttpRequest
      ? new XMLHttpRequest()
      : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open("GET", url);
    xhr.onreadystatechange = function () {
      if (xhr.readyState > 3 && xhr.status == 200) success(xhr.responseText);
    };
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.send();
    return xhr;
  }

  function openOverlay() {
    overlay.classList.add("on");
  }

  function closeOverlay() {
    overlay.classList.remove("on");
    overlayInner.innerHTML = "";
  }

  function ratioSize(el) {
    let width = el.scrollWidth,
      ratio = el.getAttribute("data-ratio"),
      height = Math.floor(width * ratio);

    el.style.height = height + "px";
  }

  function resizeImage(el) {
    let photo = el.getElementsByClassName("photo"),
      parentWidth = Math.floor(el.scrollWidth),
      parentHeight = Math.floor(el.scrollHeight),
      parentRatio = parentHeight / parentWidth,
      photoRatio = photo[0].getAttribute("data-aspect-ratio");

    if (photoRatio >= parentRatio) {
      photo[0].classList.add("size-width");
      photo[0].classList.remove("size-height");
    } else {
      photo[0].classList.add("size-height");
      photo[0].classList.remove("size-width");
    }
  }

  function resizeFrame(el) {
    let parent = el.closest(".cell");

    if (!parent) {
      return;
    }

    let pw = parent.offsetWidth,
      ph = parent.offsetHeight,
      pr = ph / pw,
      orgW = el.getAttribute("width"),
      orgH = el.getAttribute("height"),
      r = orgH / orgW;

    if (r <= pr) {
      var nw = pw;
      var nh = nw * r;
    } else {
      var nw = ph / r,
        nh = ph;
    }

    el.setAttribute("width", nw);
    el.setAttribute("height", nh);
  }

  // CUSTOM VIDEO CONTROLS ========================================

  function videoControls(player) {
    let video = player.querySelector("video");

    // check for video element, return if not found
    if (typeof video == "undefined" || video == null) {
      return;
    }

    let controls = player.querySelector(".controls");
    //let largeBtn = player.querySelector(".playBtn");
    let playpauseBtn = player.querySelector(".playpause");
    let muteBtn = player.querySelector(".mute");
    let volumeSlider = player.querySelector("#volume-bar");
    let volumeBg = player.querySelector(".volume .bg");
    let seekSlider = player.querySelector("#seek-bar");
    let seekBg = player.querySelector(".scrubber .bg");
    let fullBtn = player.querySelector(".gofull");
    let closeBtn = player.querySelector(".close-icon");
    let timestampEl = player.querySelector(".timestamp");
    let durationEl = player.querySelector(".timestamp .duration");
    let progressEl = player.querySelector(".timestamp .progress");

    // event listeners
    //video.addEventListener("canplay", videoCanPlay);
    video.addEventListener("playing", videoPlaying);
    video.addEventListener("pause", videoPaused);
    video.addEventListener("timeupdate", videoTimeUpdate);
    video.addEventListener("ended", videoEnded);
    //largeBtn.addEventListener("click", playPause);
    video.addEventListener("click", playPause);
    playpauseBtn.addEventListener("click", playPause);
    muteBtn.addEventListener("click", volumeToggle);
    seekSlider.addEventListener("input", videoSeek);
    volumeSlider.addEventListener("input", volumeChange);
    fullBtn.addEventListener("click", goFullView);
    //closeBtn.addEventListener("click", closeFullView);

    // keyboard events
    body.addEventListener("keydown", (event) => {
      // toggle play / pause of video with spacebar

      // esc key closes lightbox
      if (event.keyCode === 27 && body.classList.contains("full")) {
        event.preventDefault();
        body.classList.remove("full");
      }
    });

    // show / hide controls based on mousemovement over video
    var mousetimeout;
    player.onmousemove = function () {
      clearTimeout(mousetimeout);
      controls.classList.remove("hide");
      mousetimeout = setTimeout(function () {
        // hide video controls if no mouse movement after 2 seconds
        controls.classList.add("hide");
      }, 2000);
    };

    player.onmouseleave = function () {
      controls.classList.add("hide");
    };

    // hide controls after 2 seconds is no user action is taken
    setTimeout(function () {
      controls.classList.add("hide");
    }, 2000);

    // functions
    function playPause() {
      if (!video.paused && !video.ended) {
        video.pause();
      } else {
        video.play();
      }
    }

    function toggleFullScreen() {
      if (
        !document.fullscreenElement &&
        !document.mozFullScreen &&
        !document.webkitIsFullScreen &&
        !document.msFullscreenElement
      ) {
        if (player.requestFullscreen) {
          player.requestFullscreen();
        } else if (player.mozRequestFullScreen) {
          player.mozRequestFullScreen();
        } else if (player.webkitRequestFullscreen) {
          player.webkitRequestFullscreen();
        } else if (player.msRequestFullscreen) {
          player.msRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    }

    function videoEnded() {
      // the browser fires "pause" right before "ended", so clear the paused/playing
      // states to drop back to the poster image + play button
      player.classList.add("ended");
      player.classList.remove("paused", "playing");
      player.closest(".cell").classList.remove("full_playing");
    }

    function videoCanPlay() {
      var vid_duration = video.duration;
      let vid_minutes = 0;
      let vid_seconds = 0;

      vid_minutes = parseInt(vid_duration / 60);
      if (vid_minutes < 10) {
        vid_minutes = `${vid_minutes}`;
      }
      vid_seconds = parseInt(vid_duration) - vid_minutes * 60;
      if (vid_seconds < 10) {
        vid_seconds = `0${vid_seconds}`;
      }

      var vid_dur_output = `${vid_minutes}:${vid_seconds}`;

      durationEl.innerHTML = vid_dur_output;
    }

    function videoPlaying() {
      body.classList.add("hide_mark");
      player.classList.add("playing");
      player.classList.remove("ended");
      player.classList.remove("paused");
      timestampEl.classList.add("show");
    }

    function videoPaused() {
      player.classList.remove("playing");
      player.classList.add("paused");
      body.classList.remove("hide_mark");
    }

    function videoTimeUpdate() {
      let rawTime = video.currentTime;
      let minutes = 0;
      let seconds = 0;

      minutes = parseInt(rawTime / 60);
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      seconds = parseInt(rawTime) - minutes * 60;
      if (seconds < 10) {
        seconds = `0${seconds}`;
      }

      let output = `${minutes}:${seconds}`;
      progressEl.innerHTML = output;

      // Calculate the slider value
      var value = (100 / video.duration) * video.currentTime;

      // transition the timestamp el by animation left value
      timestampEl.style.left = value + "%";

      // Update the slider value and bg value
      seekSlider.value = value;
      seekBg.style.width = value + "%";
    }

    function videoSeek() {
      // Calculate the new time
      var time = video.duration * (seekSlider.value / 100);

      // Update the video time
      video.currentTime = time;
    }

    function volumeToggle() {
      if (video.muted == false) {
        video.muted = true;
        player.classList.add("muted");
      } else {
        video.muted = false;
        player.classList.remove("muted");
      }
    }

    function volumeChange() {
      video.volume = volumeSlider.value;
      volumeBg.style.width = volumeSlider.value * 100 + "%";
    }

    function goFullView() {
      toggleFullScreen();
    }

    function closeFullView() {
      body.classList.remove("full");
    }
  }

  // init the custom controls for all full videos on the page
  let videoPlayersEls = document.querySelectorAll(".cell.fullvideo");
  videoPlayersEls.forEach((videoPlayerEl) => {
    videoControls(videoPlayerEl);
  });

  /* HANDLE WINDOW RESIZE */

  function reportWindowSize() {}

  window.addEventListener("resize", reportWindowSize);

  /* ***************************************** */
  /* EVENTS */
  /* ***************************************** */

  // custom function for hero videos that add controls and sound on CTA click

  let heroVideoCTAs = document.querySelectorAll(".hero .play_full_video");
  heroVideoCTAs.forEach((heroVideoCTA) => {
    heroVideoCTA.addEventListener("click", function () {
      // pause the hero slideshow
      if (typeof heroFlkty != "undefined" && heroFlkty != null) {
        heroFlkty.pausePlayer();
      }

      let cell = heroVideoCTA.closest(".cell");
      let videoEl = cell.querySelector(".fullvideo video");
      let controls = cell.querySelector(".controls");

      heroVideoCTA.classList.add("hide");
      controls.classList.remove("invisible");
      cell.classList.remove("muted");
      videoEl.muted = false;
    });
  });

  function stopAllVideos() {
    let videos = document.querySelectorAll(".fullvidhold video");
    videos.forEach((video) => {
      video.pause();
      video.closest(".cell").classList.remove("full_playing");
    });

    let iframes = document.querySelectorAll("iframe");
    iframes.forEach((iframe) => {
      // check for vimeo in iframe src
      if (iframe.src.includes("vimeo")) {
        let player = new Player(iframe);
        player.pause();
      }
      let iframeCell = iframe.closest(".cell");
      if (typeof iframeCell != "undefined" && iframeCell != null) {
        iframe.closest(".cell").classList.remove("full_playing");
      }
    });
  }

  // inline video playback
  let playBtns = document.querySelectorAll(".playBtn");
  playBtns.forEach((playBtn) => {
    playBtn.addEventListener("click", function () {
      // stop any existing playing videos and iframes
      stopAllVideos();

      let cell = playBtn.closest(".cell");
      let videoType = playBtn.getAttribute("data-type");

      if (videoType === "embed") {
        // target the iframe element and attach to Vimeo API
        let iframeEl = cell.querySelector("iframe");
        // check iframeEl for vimeo
        let iframeElSrc = iframeEl.getAttribute("src");
        if (iframeElSrc.includes("vimeo")) {
          let player = new Player(iframeEl);
          player.play();

          // on pause remove full_playing class
          player.on("pause", function () {
            cell.classList.remove("full_playing");
          });
        }
      }

      if (videoType === "file") {
        let videoEl = cell.querySelector(".fullvidhold video");
        videoEl.play();
      }

      if (videoType === "url") {
        let videoEl = cell.querySelector(".fullvidhold video");
        sizeloadVideo(videoEl, "no");
      }

      cell.classList.toggle("full_playing");
    });
  });

  //INTRO SEQUENCE

  let intro = document.querySelector(".intro");
  if (typeof intro != "undefined" && intro != null) {
    let fill = document.querySelector("#logo_fill");
    let introLogo = document.querySelector(".intro_logo");

    const introTL = gsap.timeline({
      // paused: true,
      // delay: 1,
    });

    introTL
      // .from("#logo_line", { drawSVG: "50% 50%" })
      // .to("#logo_line", {
      //   duration: 1.7,
      //   drawSVG: "100% 200%",
      //   ease: "power4.inOut",
      // })
      // .to(
      //   fill,
      //   {
      //     opacity: 1,
      //   },
      //   0.7
      // )
      .to(introLogo, { opacity: 1, ease: "power2.inOut" })
      .to(intro, { y: "-100%", ease: "power2.inOut", duration: 0.8 }, 2.5);

    introTL.play();

    introTL.call(slideshowInit, null, introTL.duration() - 1);

    //NOTE: Need to add skip animation if click on screen
    // and only play intro once - cookies?
  } else {
    // wrapping this in a function so if the intro is found all slideshows will start AFTER intro sequence

    slideshowInit();
  }

  // logo change on scroll
  const logoStart = document.querySelector(".logo.start");
  const logoScroll = document.querySelector(".logo.scroll");
  let hero = document.querySelector(".hero");

  let logoTL = gsap.timeline();

  if (typeof hero != "undefined" && hero != null) {
    logoTL
      .to(logoStart, {
        opacity: 0,
        scrollTrigger: {
          trigger: logoStart,
          start: "center top",
          markers: false,
          scrub: true,
          duration: 0.2,
        },
      })
      .to(logoScroll, {
        opacity: 1,
        scrollTrigger: {
          trigger: hero,
          start: "bottom top",
          markers: false,
          scrub: true,
        },
      });
  } else {
    logoTL
      .to(logoStart, {
        opacity: 0,
        scrollTrigger: {
          trigger: logoStart,
          start: "bottom top",
          scrub: true,
        },
      })
      .to(logoScroll, {
        opacity: 1,
        scrollTrigger: {
          trigger: logoStart,
          start: "+100",
          scrub: true,
        },
      });
  }

  // Lines animation on scroll
  let lines = document.querySelectorAll(".line");
  let line1 = document.querySelector("#line1");
  let line2 = document.querySelector("#line2");
  let line3 = document.querySelector("#line3");
  let line4 = document.querySelector("#line4");
  if (typeof line1 != "undefined" && line1 != null) {
    let line1TL = gsap.timeline({});
    line1TL.fromTo(
      line1,
      { drawSVG: "30% 10%" },
      {
        drawSVG: "0% 100%",
        scrollTrigger: {
          trigger: line1,
          start: "top 70%",
          end: "top -90%",
          scrub: 1,
          repeat: 0,
          markers: false,
        },
      },
    );
  }
  if (typeof line2 != "undefined" && line2 != null) {
    let line2TL = gsap.timeline({});
    line2TL.fromTo(
      line2,
      { drawSVG: "-20% -20%" },
      {
        drawSVG: "-40% 200%",
        scrollTrigger: {
          trigger: line2,
          start: "top center",
          end: "bottom -50%",
          scrub: 1,
          markers: false,
        },
      },
    );
  }
  if (typeof line3 != "undefined" && line3 != null) {
    //Unsure why this isn't working. Maybe because this one is a path instead of a rect?
    let line3TL = gsap.timeline({});

    line3TL.fromTo(
      line3,
      { drawSVG: "30% 10%" },
      {
        drawSVG: "0% 100%",
        scrollTrigger: {
          trigger: line3,
          start: "top 70%",
          end: "top -90%",
          scrub: 1,
          repeat: 0,
          markers: false,
        },
      },
    );
  }
  if (typeof line4 != "undefined" && line4 != null) {
    let line4TL = gsap.timeline({});
    line4TL.fromTo(
      line4,
      { drawSVG: "-20% -20%" },
      {
        drawSVG: "-40% 200%",
        scrollTrigger: {
          trigger: line4,
          start: "top center",
          end: "top -90%",
          scrub: 1,
          markers: false,
        },
      },
    );
  }

  // Nav text animation
  let navTexts = document.querySelectorAll("header nav ul .container");
  const screenWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;

  if (screenWidth > 767) {
    navTexts.forEach((navText) => {
      navText.addEventListener("mouseenter", function () {
        let navLi = navText.querySelectorAll("li");
        let navTL = gsap.timeline({
          onComplete: () => gsap.set(navLi, { clearProps: true }),
        });
        navTL.to(navLi, {
          yPercent: -124,
          repeat: 0,
          duration: 0.4,
          ease: "power2.Out",
        });
      });
    });
  }

  //Marquee
  const marquee = document.querySelector(".marquee");
  if (typeof marquee != "undefined" && marquee != null) {
    const words = gsap.utils.toArray(".marquee span");
    if (words.length > 0) {
      const wordsLoop = horizontalLoop(words, {
        paused: false,
        repeat: -1,
        reversed: false,
        speed: 0.75,
      });
    }
  }

  // overlay links
  let overlayLinks = document.querySelectorAll(".openOverlay");
  overlayLinks.forEach((overlayLink) => {
    overlayLink.addEventListener("click", function (e) {
      e.preventDefault();
      // pages without includes/overlays.php have nothing to open into
      if (!overlayInner) return;
      let id = overlayLink.getAttribute("data-id");
      getAjax("/getItem.php?id=" + id, function (data) {
        overlayInner.innerHTML = data;
        // autoplay isn't reliable on video injected with innerHTML, so kick it off
        let autoVideo = overlayInner.querySelector("video[autoplay]");
        if (autoVideo) autoVideo.play().catch(() => {});
        openOverlay();
      });
    });
  });

  //hamburger menu toggle
  if (typeof menuBtn != "undefined" && menuBtn != null) {
    menuBtn.addEventListener(
      "click",
      function (event) {
        (event.preventDefault(), document.body.classList.toggle("menuOn"));
      },
      true,
    );
  }

  //Work Page Filter Nav Toggle
  let filter = document.querySelector(".filter");
  if (typeof filter != "undefined" && filter != null) {
    //Toggle the filter nav from the active item (falls back to the first item)
    let filterBtn =
      filter.querySelector("li.active") || filter.querySelector("li");
    filterBtn.addEventListener("click", function (event) {
      event.preventDefault();
      filter.classList.toggle("open");
    });
  }

  // close overlay
  if (typeof overlay != "undefined" && overlay != null) {
    overlayCloser.addEventListener(
      "click",
      function (event) {
        event.preventDefault();
        closeOverlay();
      },
      true,
    );
  }
});
